/** Categorías de convenios (slug guardado en BD). */
export const CONVENIO_CATEGORIES = [
  {
    id: 'recreacion',
    label: 'Recreación',
    description: 'Turismo, entretenimiento, sedes vacacionales aliadas y actividades de bienestar.',
  },
  {
    id: 'salud',
    label: 'Salud',
    description: 'Consultas, laboratorios, medicamentos y servicios de salud con tarifas preferenciales.',
  },
  {
    id: 'seguridad',
    label: 'Seguridad',
    description: 'Seguros, asistencia y servicios de protección para asociados y su familia.',
  },
];

export const CONVENIO_CATEGORY_IDS = CONVENIO_CATEGORIES.map((c) => c.id);

export function getConvenioCategoryLabel(id) {
  return CONVENIO_CATEGORIES.find((c) => c.id === id)?.label ?? id;
}

export function groupConveniosByCategory(items) {
  return CONVENIO_CATEGORIES.map((cat) => ({
    ...cat,
    convenios: (items ?? []).filter((c) => c.categoria === cat.id),
  })).filter((section) => section.convenios.length > 0);
}

/** Primer convenio de cada categoría (respeta el orden del listado de la API). */
export function pickOneConvenioPerCategory(items) {
  return CONVENIO_CATEGORIES.map((cat) => (items ?? []).find((c) => c.categoria === cat.id)).filter(Boolean);
}
